const enhanceLinkHrefWithRedirectUrl = (linkHref: string, redirectUrl: string) => {
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);

    return `${linkHref}?redirect_url=${encodedRedirectUrl}`;
};

export const getLoginUrl = (linkHref: string = '/login') => {
    return enhanceLinkHrefWithRedirectUrl(linkHref, window.location.href);
};
